import { render, staticRenderFns } from "./StoricoOrdini.vue?vue&type=template&id=89b30d68&"
import script from "./StoricoOrdini.vue?vue&type=script&lang=js&"
export * from "./StoricoOrdini.vue?vue&type=script&lang=js&"
import style0 from "./StoricoOrdini.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports